module.exports = __webpack_public_path__ + "1270905551b500baf8d4eef37590aeda.jpg";